import React from 'react';

const DisposableGreyIcon = ({ width = 62, height = 121, color = "#D9E2E3" }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 62 121"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            
            <rect x="3.48633" y="19.0752" width="55.0269" height="98.9247" stroke={color} strokeWidth="5" />
            <rect x="9.87305" y="3" width="14.9074" height="15.9722" stroke={color} strokeWidth="5" />
            <path d="M41.8203 32.6777L58.5139 26.4949V88.3228L41.8203 82.14V32.6777Z" fill="white" stroke={color} strokeWidth="5" />
           
        </svg>

    );
};

export default DisposableGreyIcon;